import { Controller } from "@hotwired/stimulus"
import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';

const notesPlugin = {
  id: 'notes',
  afterDatasetsDraw(chart, _args, pluginOptions) {
    const items = pluginOptions?.items;
    if (!items || items.length === 0) return;

    const { ctx, chartArea, scales: { x } } = chart;
    if (!x) return;

    ctx.save();
    ctx.strokeStyle = 'silver';
    ctx.lineWidth = 1;
    ctx.font = '10px sans-serif';
    ctx.fillStyle = '#666';
    ctx.textBaseline = 'middle';

    items.forEach(({ x: xValue, label }) => {
      const xPos = x.getPixelForValue(xValue);
      if (xPos < chartArea.left || xPos > chartArea.right) return;

      ctx.beginPath();
      ctx.moveTo(xPos, chartArea.top);
      ctx.lineTo(xPos, chartArea.bottom);
      ctx.stroke();

      if (label) {
        ctx.save();
        ctx.translate(xPos + 4, chartArea.bottom - 6);
        ctx.rotate(-Math.PI / 2);
        ctx.fillText(label, 0, 0);
        ctx.restore();
      }
    });

    ctx.restore();
  }
};

Chart.register(notesPlugin);

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object, toggleLabels: Boolean }

  connect() {
    this.chart = new Chart(this.canvasTarget.getContext('2d'), this.dataValue)

    // disable all to make it easier to toggle the ones I want to see
    if (this.toggleLabelsValue) {
      for(let i=0; i < this.chart.data.datasets.length; i++) {
        this.chart.getDatasetMeta(i).hidden=true;
      }

      this.chart.update();
    }
  }

  disconnect() {
    this.chart.destroy()
    this.chart = undefined
  }
}
